<template>
<section class="pb-2">
    <div class="text-base text-left text-gray-600 dark:text-white/75 font-semibold mt-6">
        <n-skeleton v-if="!profile.localization" :width="160" :height="20" :sharp="false" />
        <template v-else>{{ profile.localization?.comissions || 'Комиссии' }}</template>
    </div>
    <section class="flex mt-4 items-stretch">
        <div class="w-3/12 pr-2">
            <n-card
                size="small"
                :bordered="false"
                class="overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg h-full"
                :segmented="{
                    content: true,
                    footer: 'soft'
                }">

                <template #default>
                    <section class="flex">
                        <div class="text-left">
                            <n-skeleton v-if="loading" class="inline-block mt-1" :width="20" :height="26" :sharp="false" />
                            <div
                                v-else
                                class="text-gray-600 dark:text-white/75 text-2xl font-semibold">
                                {{ (profile.fullInfo.commission).split(' %')[0] }}
                                <span class="text-base dark:text-white/50 -ml-1">%</span>
                            </div>

                            <n-skeleton v-if="!profile.localization" class="inline-block mt-1" :width="30" :height="14" :sharp="false" />
                            <div v-else class="text-gray-500 dark:text-white/40 mt-1">{{ profile.localization?.profile_account_info_commission }}</div>
                        </div>
                    </section>
                </template>
                <template #footer>
                    <section class="flex items-center text-left">
                        <div class="text-gray-500 dark:text-white/40 mt-1">
                            {{ profile.localization?.profile_account_info_commission_total_month_label || 'В текущем месяце списано' }}:</div>
                        <div 
                            class="flex items-center text-base text-lightMain ml-2 whitespace-nowrap mt-1">
                            <span class="font-semibold">{{ profile.fullInfo.current_month_usd }}</span>
                            <rb-coin class="w-5 ml-2" :coin="getCurrency('usdt')" />
                        </div>
                    </section>
                </template>
            </n-card>
        </div>
        <div class="w-3/12 px-2">
            <n-card
                size="small"
                :bordered="false"
                class="overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg h-full"
                :segmented="{
                    content: true,
                    footer: 'soft'
                }">

                <template #default>
                    <section class="flex">
                        <div class="text-left">
                            <n-skeleton v-if="loading" class="inline-block mt-1" :width="20" :height="26" :sharp="false" />
                            <div
                                v-else
                                class="text-gray-600 dark:text-white/75 text-2xl font-semibold">
                                {{ (profile.fullInfo.commission_f).split(' %')[0] }}
                                <span class="text-base dark:text-white/50 -ml-1">%</span>
                            </div>

                            <n-skeleton v-if="!profile.localization" class="inline-block mt-1" :width="30" :height="14" :sharp="false" />
                            <div v-else class="text-gray-500 dark:text-white/40 mt-1">{{ profile.localization?.profile_account_info_commission_f }}</div>
                        </div>
                    </section>
                </template>
                <template #footer>
                    <section class="flex items-center text-left">
                        <div class="text-gray-500 dark:text-white/40 mt-1">
                            {{ profile.localization?.profile_account_info_commission_total_month_label || 'В текущем месяце списано' }}:</div>
                        <div 
                            class="flex items-center text-base text-lightMain ml-2 whitespace-nowrap mt-1">
                            <span class="font-semibold">{{ profile.fullInfo.current_month_usd_f }}</span>
                            <rb-coin class="w-5 ml-2" :coin="getCurrency('usdt')" />
                        </div>
                    </section>
                </template>
            </n-card>
        </div>
        <div class="w-3/12 px-2">
            <n-card
                size="small"
                :bordered="false"
                class="overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg h-full"
                :segmented="{
                    content: true,
                    footer: 'soft'
                }">

                <template #default>
                    <section class="flex">
                        <div class="text-left">
                            <n-skeleton v-if="loading" class="inline-block mt-1" :width="20" :height="26" :sharp="false" />
                            <div
                                v-else
                                class="text-gray-600 dark:text-white/75 text-2xl font-semibold">
                                {{ (profile.fullInfo.commission_fc).split(' %')[0] }}
                                <span class="text-base dark:text-white/50 -ml-1">%</span>
                            </div>

                            <n-skeleton v-if="!profile.localization" class="inline-block mt-1" :width="30" :height="14" :sharp="false" />
                            <div v-else class="text-gray-500 dark:text-white/40 mt-1">{{ profile.localization?.profile_account_info_commission_fc }}</div>
                        </div>
                    </section>
                </template>
                <template #footer>
                    <section class="flex items-center text-left">
                        <div class="text-gray-500 dark:text-white/40 mt-1">
                            {{ profile.localization?.profile_account_info_commission_total_month_label || 'В текущем месяце списано' }}:</div>
                        <div 
                            class="flex items-center text-base text-lightMain ml-2 whitespace-nowrap mt-1">
                            <span class="font-semibold">{{ profile.fullInfo.current_month_usd_fc }}</span>
                            <rb-coin class="w-5 ml-2" :coin="getCurrency('usdt')" />
                        </div>
                    </section>
                </template>
            </n-card>
        </div>
        <div class="w-3/12 pl-2">
            <n-card
                size="small"
                :bordered="false"
                class="overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg h-full"
                :segmented="{
                    content: true,
                    footer: 'soft'
                }">

                <template #default>
                    <section class="flex">
                        <div class="text-left">
                            <n-skeleton v-if="loading" class="inline-block mt-1" :width="20" :height="26" :sharp="false" />
                            <div
                                v-else
                                class="text-gray-600 dark:text-white/75 text-2xl font-semibold">
                                {{ (profile.fullInfo.commission_m).split(' %')[0] }}
                                <span class="text-base dark:text-white/50 -ml-1">%</span>
                            </div>

                            <n-skeleton v-if="!profile.localization" class="inline-block mt-1" :width="30" :height="14" :sharp="false" />
                            <div v-else class="text-gray-500 dark:text-white/40 mt-1">{{ profile.localization?.profile_account_info_commission_m }}</div>
                        </div>
                    </section>
                </template>
            </n-card>
        </div>
    </section>
</section>
</template>

<script>
// vue
import { h, ref, watch, computed } from 'vue';

// store
import { useGl } from '@store/ts/gl';
import { useEnv } from '@store/ts/env';
import { useRefs } from '@store/ts/refs';
import { useApiKeys } from '@store/apiKeys';
import { useProfile } from '@store/profile';

// i18n
import { useI18n } from 'vue-i18n';

// components
import RbCoin from '@components/rb-coin';
import TopupBalance from '@components/topup-balance';
import TelegramIcon from '@components/icons/telegram.vue';

// services
import Api from '@services/api';

// icons
import {
    Star12Filled,
    Copy16Regular,
    Dismiss16Filled,
    IosArrowRtl24Filled } from '@vicons/fluent';

// naive-ui
import {
    NTag,
    NIcon,
    NCard,
    NModal,
    NAlert,
    NSelect,
    NButton,
    NCollapseTransition } from 'naive-ui';

export default {
    name: 'profile-comissions-desktop',
    components: {
        NTag,
        NIcon,
        NCard,
        NAlert,
        NModal,
        RbCoin,
        NButton,
        NSelect,
        TopupBalance,
        Star12Filled,
        TelegramIcon,
        Copy16Regular,
        Dismiss16Filled,
        NCollapseTransition,
        IosArrowRtl24Filled,
    },
    setup() {
        // store
        const gl = useGl();
        const env = useEnv();
        const refs = useRefs();
        const profile = useProfile();

        // i18n
        const { t } = useI18n();

        const getCurrency = icon => refs.currencies.find(el => el.id === icon);

        return {
            gl,
            env,
            refs,
            window,
            profile,
            t,
            getCurrency,
        };
    },
};
</script>